module.exports = __webpack_public_path__ + "static/media/25115029_1545557705493865_1985953166_n.18b7c899.jpg";